var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#CFEBCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#CFEBCE",
    strokeOpacity: 0.2,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9375 28.1249C45.9374 27.0207 46.322 25.951 47.0252 25.0997C47.7283 24.2483 48.7061 23.6685 49.7904 23.46C50.8747 23.2515 51.9978 23.4272 52.9666 23.957C53.9354 24.4868 54.6893 25.3375 55.0988 26.363C55.5083 27.3884 55.5477 28.5245 55.2103 29.5759C54.873 30.6273 54.1798 31.5282 53.2501 32.124C52.3204 32.7197 51.2122 32.9729 50.1161 32.84C49.0199 32.7072 48.0043 32.1966 47.2438 31.3961L33.9105 38.8045C34.1142 39.5884 34.1142 40.4114 33.9105 41.1953L47.2438 48.6037C48.0406 47.766 49.1156 47.2476 50.2673 47.1458C51.4189 47.044 52.5682 47.3657 53.4997 48.0506C54.4311 48.7356 55.0807 49.7368 55.3268 50.8665C55.5728 51.9962 55.3984 53.1768 54.8362 54.1871C54.274 55.1974 53.3626 55.9679 52.2729 56.3543C51.1832 56.7406 49.9899 56.7163 48.9169 56.2858C47.8439 55.8553 46.9647 55.0482 46.4442 54.0158C45.9237 52.9834 45.7976 51.7966 46.0895 50.6779L32.7563 43.2711C32.1021 43.9598 31.2565 44.4366 30.3286 44.6399C29.4007 44.8431 28.4332 44.7636 27.551 44.4114C26.6689 44.0592 25.9125 43.4506 25.3797 42.6642C24.8469 41.8779 24.5621 40.9498 24.5621 39.9999C24.5621 39.05 24.8469 38.122 25.3797 37.3356C25.9125 36.5492 26.6689 35.9406 27.551 35.5884C28.4332 35.2363 29.4007 35.1567 30.3286 35.3599C31.2565 35.5632 32.1021 36.04 32.7563 36.7287L46.0895 29.3203C45.9883 28.9299 45.9372 28.5282 45.9375 28.1249Z",
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a2d92646003a12c5ead7d99c34b4ba5c.svg";
export { ForwardRef as ReactComponent };